import { render, staticRenderFns } from "./account-my-details.vue?vue&type=template&id=64167f8c&"
import script from "./account-my-details.vue?vue&type=script&lang=js&"
export * from "./account-my-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports